module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch1a"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch1a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HARRY")])]), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I see a pattern, but my imagination cannot picture the maker of that pattern. I see a clock, but I cannot envision the clockmaker.")])]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_vm._v("—Einstein")]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("There’s only one thing that counts: honesty. And I promise faithfully that I will never lie to you. So, no lies. And no false modesty either. I’m going to be straight about who I am and what I do.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Let’s start with myth number one: that I am a psychopath. That word comes with so much baggage but really it just means “suffering soul.” Isn’t that beautiful? How could anyone fail to be moved by the idea of a mind in torment? But slap a pseudoscientific label on the bitch, and suddenly it sounds ponderous and medical, certainly in need of medication.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Whatever, it’s a false diagnosis, based on fear and misunderstanding. Because, and here’s my thesis, we are all psychopaths under the skin. For whose soul")]), _vm._v(" doesn’t "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("suffer? Life is suffering. That’s not me, that’s the Buddha. And who could argue? Still, I much prefer the old term “psychopath” to the more modern “sociopath.” Sociopath is one of those bits of nonsense jargon—like “cadence” and “granularity”—that I hear at work all the time.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Apologies, I’m getting ahead of myself. Let me begin at the beginning and explain how my so-called psychopathy started. No names, no pack drill, obviously. But you should know that I had a relatively comfortable early childhood. Sorry to disappoint expectations, but there it is. My parents were perfectly normal. I wasn’t beaten or sexually abused or neglected. I had food to eat, a bed to sleep in, and clean clothes every day. A middle-class psychopath. Ha! In your face, analytical psychologists.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Then Harry came to live with us.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I can see what you’re thinking:")]), _vm._v(" Harry. Probably an uncle or a lodger. Harry: Abuser. Groomer. Pederast.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("No. Harry was our cat. Black and very, very furry. A rescue cat. An interesting cat. Quite possibly a psychopath himself. Certainly sly and narcissistic and without a conscience. I don’t think Harry cared about the mice he killed. He lived to find them, catch them, and watch them suffer. Harry was cruel and I had no interest in cruelty. But I was curious about Harry. He had a long bushy tail—on the surface, all fluffy fur that shed on every piece of furniture we owned—but underneath the fur, his tail was like thick wire. Harry’s tail obsessed me. It was not what it seemed, much like Harry himself. Soft yet hard. Strong yet weak. There one minute, whipped out of the way the next.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I’m sure Freud would have loved my preadolescent obsession with this phallus substitute. But, as so often with Freud, his analysis would have been off by the limits of his own understanding. You see, my interest in Harry’s tail wasn’t pseudosexual. No. It grew out of the startling discovery I’d made that one thing could in fact be two things. Once this occurred to me, of course, I saw the reality repeated everywhere. For instance, there was nice Mummy, who gave me chocolate cookies, and nasty Mummy, who got cross when I made crumbs. And so on … ")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I kept looking at Harry and thinking about his tail, and one day I knew that I wanted to see how he would react if I took a bit of the tail away. I found a notepad and wrote")]), _vm._v(" scientiffik experiment "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("on the front. Well, I was young. Then inside the notepad, I wrote down the day and made two columns: one to say what I did, the other to say how Harry reacted.")])]), _vm._v(" "), _c('p', {
    staticClass: "IMG-1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "562",
      "src": "images/table_pg24-25.jpg",
      "width": "500"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("There you have it—my first experiment. The first, but not the last.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Not by any means.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Of course, Harry")]), _vm._v(" was "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("my last animal and my last male. Soon after Harry, I reached puberty, and my thoughts turned to girls. A development that Freud himself would acknowledge was normal.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I say “girls” but really there was only one girl who mattered.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("And her legacy has been my life.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91d5924a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1a.vue
// module id = 78
// module chunks = 0